import axios from "axios";

const lerDataVigencia = async function (bodyreq) {
  var retorno = {}
  // Retornos abaixo nao precisam de interação da interface por isso estao fixos neste servico
  const dataAtual = String(new Date().getFullYear() + (new Date().getMonth + 1 ) + new Date().getDate());
  bodyreq['dataAtual'] = dataAtual
  bodyreq['perfil'] = 99
  bodyreq['proposta'] = ""
  bodyreq['vigflex'] = "0"
  bodyreq['atualiza'] = "0" 
  bodyreq['vigencia'] = ""

  try {
      await axios({
        method: 'post',
        url: process.env.VUE_APP_ALIANCAADM_SIMULACAO + '/ler/Vigencia?api-key=' + process.env.VUE_APP_ALIANCAADM_SIMULACAO_API_KEY,
        headers: { "Content-Type": "application/json" },
        data: bodyreq
      }).then(response => {
        retorno = response.data
      })
      .catch(error => {
        retorno = undefined
        console.log(error)
      })
  } catch (e) {
    console.log(e)
  }

  return retorno
};

export default lerDataVigencia;
